import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { breakpoints } from 'utils/utils'
import ScrollDownArrow from '../components/scrollDownArrow'

export default props => {
    const [ bottomPosition, setBottomPosition ] = useState(0)
    useEffect(() =>{
        const elemPosition = document.querySelector('.hero-container').getBoundingClientRect();
        setBottomPosition(elemPosition.bottom)
    },[])
    return(
        <Container className={props.classContainer ? props.classContainer + ' hero-container' : 'hero-container'}>
            <ScrollDownArrow classArrow={props.arrowHide ? props.arrowHide : ''} heroBottom={bottomPosition}/>
            {props.children}
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    min-height: 100vh;
    position: relative;
    .heroText {
        padding: 6rem 0;
    }

    &.b2b {
        flex-direction: row-reverse;
        .up-left {
            padding-bottom: 1.5rem;
        }
    }
    ${breakpoints.md}{
        flex-direction: column;
        height: auto;
        min-height: unset;
        &.b2b {
            flex-direction: column;
        }
    }
`